import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { MeshGeometry, MeshMaterial, Mesh } from '@pixi/mesh';
import { BitmapFont } from './BitmapFont.mjs';
import './utils/index.mjs';
import msdfFrag from './shader/msdf.mjs';
import msdfVert from './shader/msdf2.mjs';
import { ObservablePoint, settings, Point, Texture, utils, BLEND_MODES, Program } from '@pixi/core';
import { Container } from '@pixi/display';
import { splitTextToCharacters } from './utils/splitTextToCharacters.mjs';
import { extractCharCode } from './utils/extractCharCode.mjs';
var pageMeshDataDefaultPageMeshData = [];
var pageMeshDataMSDFPageMeshData = [];
var charRenderDataPool = [];
var _BitmapText = /*#__PURE__*/function (_Container) {
  _inherits(_BitmapText, _Container);
  var _super = _createSuper(_BitmapText);
  function _BitmapText(text) {
    var _this;
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, _BitmapText);
    _this = _super.call(this);
    _this._tint = 16777215;
    var _Object$assign = Object.assign({}, _BitmapText.styleDefaults, style),
      align = _Object$assign.align,
      tint = _Object$assign.tint,
      maxWidth = _Object$assign.maxWidth,
      letterSpacing = _Object$assign.letterSpacing,
      fontName = _Object$assign.fontName,
      fontSize = _Object$assign.fontSize;
    if (!BitmapFont.available[fontName]) {
      throw new Error("Missing BitmapFont \"".concat(fontName, "\""));
    }
    _this._activePagesMeshData = [];
    _this._textWidth = 0;
    _this._textHeight = 0;
    _this._align = align;
    _this._tint = tint;
    _this._font = void 0;
    _this._fontName = fontName;
    _this._fontSize = fontSize;
    _this.text = text;
    _this._maxWidth = maxWidth;
    _this._maxLineHeight = 0;
    _this._letterSpacing = letterSpacing;
    _this._anchor = new ObservablePoint(function () {
      _this.dirty = true;
    }, _assertThisInitialized(_this), 0, 0);
    _this._roundPixels = settings.ROUND_PIXELS;
    _this.dirty = true;
    _this._resolution = settings.RESOLUTION;
    _this._autoResolution = true;
    _this._textureCache = {};
    return _this;
  }
  _createClass(_BitmapText, [{
    key: "updateText",
    value: function updateText() {
      var data = BitmapFont.available[this._fontName];
      var fontSize = this.fontSize;
      var scale = fontSize / data.size;
      var pos = new Point();
      var chars = [];
      var lineWidths = [];
      var lineSpaces = [];
      var text = this._text.replace(/(?:\r\n|\r)/g, "\n") || " ";
      var charsInput = splitTextToCharacters(text);
      var maxWidth = this._maxWidth * data.size / fontSize;
      var pageMeshDataPool = data.distanceFieldType === "none" ? pageMeshDataDefaultPageMeshData : pageMeshDataMSDFPageMeshData;
      var prevCharCode = null;
      var lastLineWidth = 0;
      var maxLineWidth = 0;
      var line = 0;
      var lastBreakPos = -1;
      var lastBreakWidth = 0;
      var spacesRemoved = 0;
      var maxLineHeight = 0;
      var spaceCount = 0;
      for (var i = 0; i < charsInput.length; i++) {
        var char = charsInput[i];
        var charCode = extractCharCode(char);
        if (/(?:\s)/.test(char)) {
          lastBreakPos = i;
          lastBreakWidth = lastLineWidth;
          spaceCount++;
        }
        if (char === "\r" || char === "\n") {
          lineWidths.push(lastLineWidth);
          lineSpaces.push(-1);
          maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
          ++line;
          ++spacesRemoved;
          pos.x = 0;
          pos.y += data.lineHeight;
          prevCharCode = null;
          spaceCount = 0;
          continue;
        }
        var charData = data.chars[charCode];
        if (!charData) {
          continue;
        }
        if (prevCharCode && charData.kerning[prevCharCode]) {
          pos.x += charData.kerning[prevCharCode];
        }
        var charRenderData = charRenderDataPool.pop() || {
          texture: Texture.EMPTY,
          line: 0,
          charCode: 0,
          prevSpaces: 0,
          position: new Point()
        };
        charRenderData.texture = charData.texture;
        charRenderData.line = line;
        charRenderData.charCode = charCode;
        charRenderData.position.x = pos.x + charData.xOffset + this._letterSpacing / 2;
        charRenderData.position.y = pos.y + charData.yOffset;
        charRenderData.prevSpaces = spaceCount;
        chars.push(charRenderData);
        lastLineWidth = charRenderData.position.x + Math.max(charData.xAdvance - charData.xOffset, charData.texture.orig.width);
        pos.x += charData.xAdvance + this._letterSpacing;
        maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
        prevCharCode = charCode;
        if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
          ++spacesRemoved;
          utils.removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
          i = lastBreakPos;
          lastBreakPos = -1;
          lineWidths.push(lastBreakWidth);
          lineSpaces.push(chars.length > 0 ? chars[chars.length - 1].prevSpaces : 0);
          maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
          line++;
          pos.x = 0;
          pos.y += data.lineHeight;
          prevCharCode = null;
          spaceCount = 0;
        }
      }
      var lastChar = charsInput[charsInput.length - 1];
      if (lastChar !== "\r" && lastChar !== "\n") {
        if (/(?:\s)/.test(lastChar)) {
          lastLineWidth = lastBreakWidth;
        }
        lineWidths.push(lastLineWidth);
        maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
        lineSpaces.push(-1);
      }
      var lineAlignOffsets = [];
      for (var _i = 0; _i <= line; _i++) {
        var alignOffset = 0;
        if (this._align === "right") {
          alignOffset = maxLineWidth - lineWidths[_i];
        } else if (this._align === "center") {
          alignOffset = (maxLineWidth - lineWidths[_i]) / 2;
        } else if (this._align === "justify") {
          alignOffset = lineSpaces[_i] < 0 ? 0 : (maxLineWidth - lineWidths[_i]) / lineSpaces[_i];
        }
        lineAlignOffsets.push(alignOffset);
      }
      var lenChars = chars.length;
      var pagesMeshData = {};
      var newPagesMeshData = [];
      var activePagesMeshData = this._activePagesMeshData;
      pageMeshDataPool.push.apply(pageMeshDataPool, _toConsumableArray(activePagesMeshData));
      for (var _i2 = 0; _i2 < lenChars; _i2++) {
        var texture = chars[_i2].texture;
        var baseTextureUid = texture.baseTexture.uid;
        if (!pagesMeshData[baseTextureUid]) {
          var pageMeshData = pageMeshDataPool.pop();
          if (!pageMeshData) {
            var geometry = new MeshGeometry();
            var material = void 0;
            var meshBlendMode = void 0;
            if (data.distanceFieldType === "none") {
              material = new MeshMaterial(Texture.EMPTY);
              meshBlendMode = BLEND_MODES.NORMAL;
            } else {
              material = new MeshMaterial(Texture.EMPTY, {
                program: Program.from(msdfVert, msdfFrag),
                uniforms: {
                  uFWidth: 0
                }
              });
              meshBlendMode = BLEND_MODES.NORMAL_NPM;
            }
            var mesh = new Mesh(geometry, material);
            mesh.blendMode = meshBlendMode;
            pageMeshData = {
              index: 0,
              indexCount: 0,
              vertexCount: 0,
              uvsCount: 0,
              total: 0,
              mesh: mesh,
              vertices: null,
              uvs: null,
              indices: null
            };
          }
          pageMeshData.index = 0;
          pageMeshData.indexCount = 0;
          pageMeshData.vertexCount = 0;
          pageMeshData.uvsCount = 0;
          pageMeshData.total = 0;
          var _textureCache = this._textureCache;
          _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new Texture(texture.baseTexture);
          pageMeshData.mesh.texture = _textureCache[baseTextureUid];
          pageMeshData.mesh.tint = this._tint;
          newPagesMeshData.push(pageMeshData);
          pagesMeshData[baseTextureUid] = pageMeshData;
        }
        pagesMeshData[baseTextureUid].total++;
      }
      for (var _i3 = 0; _i3 < activePagesMeshData.length; _i3++) {
        if (!newPagesMeshData.includes(activePagesMeshData[_i3])) {
          this.removeChild(activePagesMeshData[_i3].mesh);
        }
      }
      for (var _i4 = 0; _i4 < newPagesMeshData.length; _i4++) {
        if (newPagesMeshData[_i4].mesh.parent !== this) {
          this.addChild(newPagesMeshData[_i4].mesh);
        }
      }
      this._activePagesMeshData = newPagesMeshData;
      for (var _i5 in pagesMeshData) {
        var _pageMeshData$indices;
        var _pageMeshData = pagesMeshData[_i5];
        var total = _pageMeshData.total;
        if (!(((_pageMeshData$indices = _pageMeshData.indices) === null || _pageMeshData$indices === void 0 ? void 0 : _pageMeshData$indices.length) > 6 * total) || _pageMeshData.vertices.length < Mesh.BATCHABLE_SIZE * 2) {
          _pageMeshData.vertices = new Float32Array(4 * 2 * total);
          _pageMeshData.uvs = new Float32Array(4 * 2 * total);
          _pageMeshData.indices = new Uint16Array(6 * total);
        } else {
          var total2 = _pageMeshData.total;
          var vertices = _pageMeshData.vertices;
          for (var i2 = total2 * 4 * 2; i2 < vertices.length; i2++) {
            vertices[i2] = 0;
          }
        }
        _pageMeshData.mesh.size = 6 * total;
      }
      for (var _i6 = 0; _i6 < lenChars; _i6++) {
        var _char = chars[_i6];
        var offset = _char.position.x + lineAlignOffsets[_char.line] * (this._align === "justify" ? _char.prevSpaces : 1);
        if (this._roundPixels) {
          offset = Math.round(offset);
        }
        var xPos = offset * scale;
        var yPos = _char.position.y * scale;
        var _texture = _char.texture;
        var pageMesh = pagesMeshData[_texture.baseTexture.uid];
        var textureFrame = _texture.frame;
        var textureUvs = _texture._uvs;
        var index = pageMesh.index++;
        pageMesh.indices[index * 6 + 0] = 0 + index * 4;
        pageMesh.indices[index * 6 + 1] = 1 + index * 4;
        pageMesh.indices[index * 6 + 2] = 2 + index * 4;
        pageMesh.indices[index * 6 + 3] = 0 + index * 4;
        pageMesh.indices[index * 6 + 4] = 2 + index * 4;
        pageMesh.indices[index * 6 + 5] = 3 + index * 4;
        pageMesh.vertices[index * 8 + 0] = xPos;
        pageMesh.vertices[index * 8 + 1] = yPos;
        pageMesh.vertices[index * 8 + 2] = xPos + textureFrame.width * scale;
        pageMesh.vertices[index * 8 + 3] = yPos;
        pageMesh.vertices[index * 8 + 4] = xPos + textureFrame.width * scale;
        pageMesh.vertices[index * 8 + 5] = yPos + textureFrame.height * scale;
        pageMesh.vertices[index * 8 + 6] = xPos;
        pageMesh.vertices[index * 8 + 7] = yPos + textureFrame.height * scale;
        pageMesh.uvs[index * 8 + 0] = textureUvs.x0;
        pageMesh.uvs[index * 8 + 1] = textureUvs.y0;
        pageMesh.uvs[index * 8 + 2] = textureUvs.x1;
        pageMesh.uvs[index * 8 + 3] = textureUvs.y1;
        pageMesh.uvs[index * 8 + 4] = textureUvs.x2;
        pageMesh.uvs[index * 8 + 5] = textureUvs.y2;
        pageMesh.uvs[index * 8 + 6] = textureUvs.x3;
        pageMesh.uvs[index * 8 + 7] = textureUvs.y3;
      }
      this._textWidth = maxLineWidth * scale;
      this._textHeight = (pos.y + data.lineHeight) * scale;
      for (var _i7 in pagesMeshData) {
        var _pageMeshData2 = pagesMeshData[_i7];
        if (this.anchor.x !== 0 || this.anchor.y !== 0) {
          var vertexCount = 0;
          var anchorOffsetX = this._textWidth * this.anchor.x;
          var anchorOffsetY = this._textHeight * this.anchor.y;
          for (var _i8 = 0; _i8 < _pageMeshData2.total; _i8++) {
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetX;
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetY;
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetX;
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetY;
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetX;
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetY;
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetX;
            _pageMeshData2.vertices[vertexCount++] -= anchorOffsetY;
          }
        }
        this._maxLineHeight = maxLineHeight * scale;
        var vertexBuffer = _pageMeshData2.mesh.geometry.getBuffer("aVertexPosition");
        var textureBuffer = _pageMeshData2.mesh.geometry.getBuffer("aTextureCoord");
        var indexBuffer = _pageMeshData2.mesh.geometry.getIndex();
        vertexBuffer.data = _pageMeshData2.vertices;
        textureBuffer.data = _pageMeshData2.uvs;
        indexBuffer.data = _pageMeshData2.indices;
        vertexBuffer.update();
        textureBuffer.update();
        indexBuffer.update();
      }
      for (var _i9 = 0; _i9 < chars.length; _i9++) {
        charRenderDataPool.push(chars[_i9]);
      }
      this._font = data;
      this.dirty = false;
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      this.validate();
      this.containerUpdateTransform();
    }
  }, {
    key: "_render",
    value: function _render(renderer) {
      if (this._autoResolution && this._resolution !== renderer.resolution) {
        this._resolution = renderer.resolution;
        this.dirty = true;
      }
      var _BitmapFont$available = BitmapFont.available[this._fontName],
        distanceFieldRange = _BitmapFont$available.distanceFieldRange,
        distanceFieldType = _BitmapFont$available.distanceFieldType,
        size = _BitmapFont$available.size;
      if (distanceFieldType !== "none") {
        var _this$worldTransform = this.worldTransform,
          a = _this$worldTransform.a,
          b = _this$worldTransform.b,
          c = _this$worldTransform.c,
          d = _this$worldTransform.d;
        var dx = Math.sqrt(a * a + b * b);
        var dy = Math.sqrt(c * c + d * d);
        var worldScale = (Math.abs(dx) + Math.abs(dy)) / 2;
        var fontScale = this.fontSize / size;
        var resolution = renderer._view.resolution;
        var _iterator = _createForOfIteratorHelper(this._activePagesMeshData),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mesh = _step.value;
            mesh.mesh.shader.uniforms.uFWidth = worldScale * distanceFieldRange * fontScale * resolution;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      _get(_getPrototypeOf(_BitmapText.prototype), "_render", this).call(this, renderer);
    }
  }, {
    key: "getLocalBounds",
    value: function getLocalBounds() {
      this.validate();
      return _get(_getPrototypeOf(_BitmapText.prototype), "getLocalBounds", this).call(this);
    }
  }, {
    key: "validate",
    value: function validate() {
      var font = BitmapFont.available[this._fontName];
      if (!font) {
        throw new Error("Missing BitmapFont \"".concat(this._fontName, "\""));
      }
      if (this._font !== font) {
        this.dirty = true;
      }
      if (this.dirty) {
        this.updateText();
      }
    }
  }, {
    key: "tint",
    get: function get() {
      return this._tint;
    },
    set: function set(value) {
      if (this._tint === value) return;
      this._tint = value;
      for (var i = 0; i < this._activePagesMeshData.length; i++) {
        this._activePagesMeshData[i].mesh.tint = value;
      }
    }
  }, {
    key: "align",
    get: function get() {
      return this._align;
    },
    set: function set(value) {
      if (this._align !== value) {
        this._align = value;
        this.dirty = true;
      }
    }
  }, {
    key: "fontName",
    get: function get() {
      return this._fontName;
    },
    set: function set(value) {
      if (!BitmapFont.available[value]) {
        throw new Error("Missing BitmapFont \"".concat(value, "\""));
      }
      if (this._fontName !== value) {
        this._fontName = value;
        this.dirty = true;
      }
    }
  }, {
    key: "fontSize",
    get: function get() {
      var _this$_fontSize;
      return (_this$_fontSize = this._fontSize) !== null && _this$_fontSize !== void 0 ? _this$_fontSize : BitmapFont.available[this._fontName].size;
    },
    set: function set(value) {
      if (this._fontSize !== value) {
        this._fontSize = value;
        this.dirty = true;
      }
    }
  }, {
    key: "anchor",
    get: function get() {
      return this._anchor;
    },
    set: function set(value) {
      if (typeof value === "number") {
        this._anchor.set(value);
      } else {
        this._anchor.copyFrom(value);
      }
    }
  }, {
    key: "text",
    get: function get() {
      return this._text;
    },
    set: function set(text) {
      text = String(text === null || text === void 0 ? "" : text);
      if (this._text === text) {
        return;
      }
      this._text = text;
      this.dirty = true;
    }
  }, {
    key: "maxWidth",
    get: function get() {
      return this._maxWidth;
    },
    set: function set(value) {
      if (this._maxWidth === value) {
        return;
      }
      this._maxWidth = value;
      this.dirty = true;
    }
  }, {
    key: "maxLineHeight",
    get: function get() {
      this.validate();
      return this._maxLineHeight;
    }
  }, {
    key: "textWidth",
    get: function get() {
      this.validate();
      return this._textWidth;
    }
  }, {
    key: "letterSpacing",
    get: function get() {
      return this._letterSpacing;
    },
    set: function set(value) {
      if (this._letterSpacing !== value) {
        this._letterSpacing = value;
        this.dirty = true;
      }
    }
  }, {
    key: "roundPixels",
    get: function get() {
      return this._roundPixels;
    },
    set: function set(value) {
      if (value !== this._roundPixels) {
        this._roundPixels = value;
        this.dirty = true;
      }
    }
  }, {
    key: "textHeight",
    get: function get() {
      this.validate();
      return this._textHeight;
    }
  }, {
    key: "resolution",
    get: function get() {
      return this._resolution;
    },
    set: function set(value) {
      this._autoResolution = false;
      if (this._resolution === value) {
        return;
      }
      this._resolution = value;
      this.dirty = true;
    }
  }, {
    key: "destroy",
    value: function destroy(options) {
      var _textureCache = this._textureCache;
      var data = BitmapFont.available[this._fontName];
      var pageMeshDataPool = data.distanceFieldType === "none" ? pageMeshDataDefaultPageMeshData : pageMeshDataMSDFPageMeshData;
      pageMeshDataPool.push.apply(pageMeshDataPool, _toConsumableArray(this._activePagesMeshData));
      var _iterator2 = _createForOfIteratorHelper(this._activePagesMeshData),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var pageMeshData = _step2.value;
          this.removeChild(pageMeshData.mesh);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this._activePagesMeshData = [];
      pageMeshDataPool.filter(function (page) {
        return _textureCache[page.mesh.texture.baseTexture.uid];
      }).forEach(function (page) {
        page.mesh.texture = Texture.EMPTY;
      });
      for (var id in _textureCache) {
        var texture = _textureCache[id];
        texture.destroy();
        delete _textureCache[id];
      }
      this._font = null;
      this._textureCache = null;
      _get(_getPrototypeOf(_BitmapText.prototype), "destroy", this).call(this, options);
    }
  }]);
  return _BitmapText;
}(Container);
var BitmapText = _BitmapText;
BitmapText.styleDefaults = {
  align: "left",
  tint: 16777215,
  maxWidth: 0,
  letterSpacing: 0
};
export { BitmapText };